import React, {useEffect, useState} from 'react'
import {Flex, Stack, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {useGigya} from '../../context/gigya'
import {FormattedMessage, useIntl} from 'react-intl'
import GigyaBasicFormController from '../../utils/gigya/lite-registration'
import useGigyaCustomer from '../../custom-hooks/use-gigya-customer'
import {useCurrentCustomer} from '../../hooks/use-current-customer'
import PropTypes from 'prop-types'
import {useToast} from '../../hooks/use-toast'
import {getMarketingPreferences} from '../../utils/gigya'
import {BRAND_KEY} from '../../brand'
import useGigyaSSR from '../../custom-hooks/use-gigya-ssr'
import {useLocaleCountry} from '../../hooks/use-locale-custom'

const UserNewsletterBanner = ({description}) => {
    const countryCode = useLocaleCountry()
    const styles = useMultiStyleConfig('UserNewsletterBanner')
    const stylesLogin = useMultiStyleConfig('Login', {
        variant: countryCode === 'DE' ? 'userNewsletterDE' : 'userNewsletter',
    })

    const {data: customer} = useCurrentCustomer()
    const toast = useToast()
    const {formatMessage} = useIntl()
    const ssrGigyaMethods = useGigyaSSR()

    const {gigyaObject} = useGigya()
    const [isLoaded, setIsLoaded] = useState(false)

    const {data: gigyaCustomer} = useGigyaCustomer(customer, {
        enabled: !!customer?.c_gigyaId,
    })

    useEffect(() => {
        window.DLG = {
            ...(window.DLG || {}),
            gigya: {brand: BRAND_KEY},
        }
        return () => {
            delete window.DLG
        }
    }, [])

    useEffect(() => {
        if (isLoaded || !gigyaObject || !gigyaCustomer || getMarketingPreferences(gigyaCustomer))
            return

        gigyaObject.accounts.showScreenSet({
            screenSet: 'Default-LiteRegistration',
            startScreen: 'gigya-newsletter-screen',
            containerID: 'newsletter',
            deviceType: 'desktop',
            onBeforeScreenLoad: () => {},
            onAfterScreenLoad: () => {
                setIsLoaded(true)
            },
            onBeforeValidation: () => {},
            onBeforeSubmit: (e) => {
                let proceed = GigyaBasicFormController.onBeforeSubmit(
                    e,
                    '.gigya-input-checkbox:not(.subscription-checkbox)',
                    true,
                )

                return proceed
            },
            onSubmit: (e) => {
                GigyaBasicFormController.onSubmit(
                    e,
                    null,
                    '.gigya-input-checkbox:not(.subscription-checkbox)',
                )
            },
            onAfterSubmit: async (e) => {
                await GigyaBasicFormController.onAfterSubmit(e, ssrGigyaMethods, null, false)
                toast({
                    title: formatMessage({
                        defaultMessage: 'Thank you for subscribing to our newsletter!',
                        id: 'user-newsletter-banner.success',
                    }),
                    status: 'success',
                })
                const wrapper = document.getElementById(e.sourceContainerID)
                const inputs = wrapper.querySelectorAll('input, button')
                inputs.forEach((el) => {
                    el.disabled = true
                })
            },
            onError: () => {
                toast({
                    title: formatMessage({
                        defaultMessage: 'Something went wrong',
                        id: 'user-newsletter-banner.error',
                    }),
                    status: 'error',
                })
            },
            onFieldChanged: () => {},
        })
    }, [gigyaObject, gigyaCustomer])

    return (
        <Flex {...styles?.container} display={isLoaded ? 'flex' : 'none'}>
            <Text {...styles?.title}>
                <FormattedMessage
                    defaultMessage="Subscribe to our newsletter"
                    id="user-newsletter-banner.title"
                />
            </Text>
            {description && <Text {...styles?.description}>{description}</Text>}
            <Stack
                {...styles?.registrationFormStack}
                __css={{
                    ...stylesLogin,
                }}
            >
                <div id="newsletter"></div>
            </Stack>
        </Flex>
    )
}
UserNewsletterBanner.propTypes = {
    description: PropTypes.any,
}
export default UserNewsletterBanner
